import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["active"]
const _hoisted_2 = { class: "tw-p-4 tw-flex tw-items-center tw-justify-between" }
const _hoisted_3 = ["onClick"]

import { useScreenSize } from 'src/functions';
    import { PropType, computed, onMounted, ref, watch } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SelectMulti',
  props: {
        modelValue:{
            type: Array as PropType<string[]>,
            default: () => [] 
        },
        options: {
            type: Array as PropType<{ label: string, value: string, selected: boolean }[]>,
            default: () => []
        },
        placeholderText:{
            type: String,
            default: ''
        },
        clearable: {
            type: Boolean,
            default: false
        },
        useInput: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        },
        labelClass:{
            type: String,
            default: ''
        }
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

    const props = __props

    const screen = useScreenSize();

    onMounted(() => {
        filteredValues.value = props.options;
    });

    const emit = __emit;
    const value = computed<string[]>({
        get() {
            return props.modelValue;
        },
        set(value: string[]) {
            emit('update:modelValue', value);
        }
    });

    const displayValue = computed(() => {
        if (value.value !== null && value.value.length > 0) {
        return `${value.value.length} Selected`;
        } else {
        return null;
        }
    });

    function clear() {
        value.value = [];
    }

    const filteredValues = ref<{ label: string, value: string, selected: boolean }[]>([]);
    function filterFn(val: string, update: Function) {
        if (val === '') {
            update(() => {
                filteredValues.value = props.options;
            });
            return;
        }

        update(() => {
            const needle = val.toLowerCase();
            filteredValues.value = props.options.filter(v => v.label.toLowerCase().includes(needle));
        });
    }

    const allSelected = ref(false);
    function toggleSelectAll() {
        allSelected.value = !allSelected.value;
        if (allSelected.value === false) {
            props.options.forEach(o => o.selected = false);
            value.value = [];
        }
        else {
            props.options.forEach(o => o.selected = true);
            value.value = props.options.map(o => o.value);
        }
    }

    watch(() => props.options, (newOptions) => {
        filteredValues.value = newOptions;
        allSelected.value = newOptions.every(o => o.selected);
    }, { deep: true });

return (_ctx: any,_cache: any) => {
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["tw-text-slate-700 tw-text-sm tw-pb-[2px]", __props.labelClass])
    }, _toDisplayString(__props.label), 3),
    _createVNode(_component_q_select, {
      outlined: "",
      dense: "",
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      clearable: __props.clearable,
      multiple: "",
      "use-input": __props.useInput,
      "input-debounce": "300",
      filter: true,
      "display-value": displayValue.value ?? undefined,
      placeholder: __props.placeholderText,
      "emit-value": "",
      onClear: clear,
      onFilter: filterFn,
      "option-label": "label",
      class: "tw-shadow-sm",
      options: filteredValues.value ?? undefined,
      "popup-content-class": "tw-text-sm limit-dd-height",
      behavior: _unref(screen).lte('sm') ? 'dialog' : 'menu',
      "data-clarity-unmask": "true"
    }, {
      option: _withCtx(({ opt, index }) => [
        (index === 0 && filteredValues.value && filteredValues.value.length === __props.options.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: toggleSelectAll,
              clickable: "",
              active: allSelected.value
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", {
                  class: _normalizeClass(["tw-text-sm tw-pb-[2px]", allSelected.value ? 'tw-text-brand-700' : 'tw-text-slate-600'])
                }, " Select All ", 2),
                _createVNode(_component_Toggle, {
                  "model-value": allSelected.value,
                  "onUpdate:modelValue": toggleSelectAll
                }, null, 8, ["model-value"])
              ])
            ], 8, _hoisted_1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "tw-p-4 tw-flex tw-items-center tw-justify-between",
          onClick: _withModifiers(($event: any) => (opt.selected = !opt.selected), ["prevent"])
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["tw-text-sm tw-pb-[2px]", opt.selected ? 'tw-text-brand-700' : 'tw-text-slate-600'])
          }, _toDisplayString(opt.label), 3),
          _createVNode(_component_Toggle, {
            "model-value": opt.selected,
            "onUpdate:modelValue": (val) => opt.selected = val
          }, null, 8, ["model-value", "onUpdate:modelValue"])
        ], 8, _hoisted_3)
      ]),
      _: 1
    }, 8, ["modelValue", "clearable", "use-input", "display-value", "placeholder", "options", "behavior"])
  ], 64))
}
}

})